// extracted by mini-css-extract-plugin
export default {"infos":"screens_infos__boE3y","value":"screens_value__jgKlM","confirmBox":"screens_confirmBox__kyhEg","title":"screens_title__MkNe0","txt":"screens_txt__PKmGZ"};